module.exports = __webpack_public_path__ + "static/img/SketchPngcd18487937a95d7e4b35a1547ddde50aefebcf73642cde8c6ab7ab9379b9df35.18319ae9.png";